import React from 'react';
import { clsx, multiply, createUseStyles } from '@pushpay/styles';
import { shimmerRowAnimation, shimmerAnimation, getShimmerStyles, getColors } from './shared';
const useStyles = createUseStyles(theme => {
  const {
    baseColor,
    shimmerColor
  } = getColors(theme);
  return {
    root: ({
      width
    }) => ({
      display: 'flex',
      width: `${width}%`
    }),
    avatar: { ...getShimmerStyles(theme, {
        opacity: 0,
        backgroundColor: shimmerColor,
        animation: '$shimmer 2s infinite',
        borderRadius: theme.SHAPE.CIRCULAR
      }),
      width: '1.5em',
      borderRadius: theme.SHAPE.CIRCULAR,
      marginRight: multiply(theme.SPACING.GUTTER, 2),
      transform: 'scale(1.3)'
    },
    content: { ...getShimmerStyles(theme, {
        width: 0,
        backgroundImage: `linear-gradient(to left, ${baseColor} 25%, ${shimmerColor} 40%, ${baseColor} 80%)`,
        animation: '$shimmer-row 2s infinite'
      }),
      height: '1.5em',
      overflow: 'hidden',
      flex: '1 1 auto',
      borderRadius: '1em'
    },
    ...shimmerRowAnimation,
    ...shimmerAnimation
  };
});
export const SkeletonRow = props => {
  const {
    avatar,
    classes: classesProp,
    className: classNameProp,
    width = 100
  } = props;
  const classes = useStyles(classesProp, {
    width
  });
  const className = clsx(classes.root, classNameProp);
  return /*#__PURE__*/React.createElement("li", {
    className: className
  }, avatar && /*#__PURE__*/React.createElement("span", {
    className: classes.avatar
  }), /*#__PURE__*/React.createElement("span", {
    className: classes.content
  }));
};